/**
 * Base class to describe an export data provider
 */
import ExportDataProvider from "./export-data-provider";
import {downloadCsv, generateCsvContent} from "../../../helpers/csv-helpers";
import moment from "moment";

export default class CsvExportDataProvider extends ExportDataProvider
{
    /**
     *  Export data base method
     * @param {DataProvider} dataProvider The data provider to source the data required
     * @param {Array} layout The data layout for exporting
     * @param {any} context Optional contextual data for exporting
     */
    exportData(dataProvider,layout, context)
    {
        context.isExporting = true;
        return dataProvider
            .refreshData(context)
            .then(({elements}) => {
                const csvData = generateCsvContent(elements, layout);
                const filename = `${context.name || "export"}-${moment().format("DDMMYY")}.csv`;
                downloadCsv(csvData, filename);
            })
    }
}